import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const ChangeOnHold = ({ caseId, showModal, handleClose }) => {
  const [selectedStatus, setSelectedStatus] = useState('Not On Hold');
  const [customStatus, setCustomStatus] = useState('');
  const [statusUpdatedAt, setStatusUpdatedAt] = useState(null);

  const holdOptions = [
    'Not On Hold',
    'Metal try-in',
    'Bite block',
    'Die trim',
    'Frame try-in',
    'Problem with case',
    'Hold Case',
    'In lab - no date yet',
    'Hold for model mod.',
    'Hold for study mod.',
    'Hold for work. mod.',
    'Hold for picture',
    'Hold for shade',
    'Hold for bite',
    'Hold for components',
    'Hold for Impression',
    'Hold for partial',
    'Wax try-in',
    'Dr. requested call',
    'Bisque bake try-in',
    'Other'
  ];

  useEffect(() => {
    if (showModal && caseId) {
      const fetchStatus = async () => {
        try {
          const response = await axios.get(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          const fetchedStatus = response.data.status || 'in progress';
          const fetchedUpdatedAt = response.data.statusUpdatedAt;

          if (fetchedStatus === 'in progress') {
            setSelectedStatus('Not On Hold');
          } else {
            if (holdOptions.includes(fetchedStatus)) {
              setSelectedStatus(fetchedStatus);
            } else {
              setSelectedStatus('Other');
              setCustomStatus(fetchedStatus);
            }
          }

          setStatusUpdatedAt(fetchedUpdatedAt ? new Date(fetchedUpdatedAt).toLocaleString() : 'N/A');
        } catch (error) {
          console.error('❌ Error fetching case status:', error);
        }
      };

      fetchStatus();
    }
  }, [showModal, caseId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newStatus;
    if (selectedStatus === 'Not On Hold') {
      newStatus = 'in progress';
    } else if (selectedStatus === 'Other') {
      if (!customStatus.trim()) {
        alert('Please enter a custom status');
        return;
      }
      newStatus = customStatus;
    } else {
      newStatus = selectedStatus;
    }

    try {
      const response = await axios.put(`https://hms.backend.hiragroupcloud.com/api/cases/updateStatus/${caseId}`, { status: newStatus }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      
      alert('Status updated successfully');
      handleClose();
    } catch (error) {
      console.error('❌ Error updating status:', error);
      alert('Failed to update status');
    }
  };

  const containerStyled = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '20px 0',
    flexDirection: 'row'
  };

  const dropdownStyling = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '200px',
    height: "31px",
    cursor: 'pointer',
    marginLeft: '60px'
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" size="lg">
        <Modal.Header closeButton style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
        }}>
          <Modal.Title style={{ color: 'white' }}> On Hold Status </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div style={containerStyled}>
              <b>Status *</b>
              <select
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  if (e.target.value !== 'Other') setCustomStatus('');
                }}
                style={dropdownStyling}
              >
                {holdOptions.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
            {selectedStatus === 'Other' && (
              <div style={{ marginBottom: '15px' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Custom Status *</label>
                <textarea
                  value={customStatus}
                  onChange={(e) => setCustomStatus(e.target.value)}
                  rows={4}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#f9f9f9',
                    fontSize: '16px',
                  }}
                />
              </div>
            )}
            <p>Last updated: {statusUpdatedAt}</p>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
          }} onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
          }} onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChangeOnHold; 